export var FileType;

(function (FileType) {
  FileType[FileType["IMAGE"] = 0] = "IMAGE";
  FileType[FileType["AUDIO"] = 1] = "AUDIO";
  FileType[FileType["VIDEO"] = 2] = "VIDEO";
  FileType[FileType["TEXT"] = 3] = "TEXT";
  FileType[FileType["PDF"] = 4] = "PDF";
  FileType[FileType["EXCEL"] = 5] = "EXCEL";
  FileType[FileType["WORD"] = 6] = "WORD";
  FileType[FileType["PPT"] = 7] = "PPT";
  FileType[FileType["TXT"] = 8] = "TXT";
  FileType[FileType["UNKNOWN"] = 9] = "UNKNOWN";
})(FileType || (FileType = {}));


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/types.js
// module id = 357
// module chunks = 4